import { Wine, Check } from "lucide-react";

const perks = [
  "Two complimentary tastings each year",
  "Member-only pricing on all wines",
  "First access to limited estate releases",
  "Invitations to harvest & long-lunch events",
];

export default function WineClub() {
  const scrollToBook = () => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="wine-club" data-testid="wine-club-section" className="py-24 md:py-32 bg-[#722F37] text-white">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <div className="mx-auto h-14 w-14 rounded-full bg-white/10 flex items-center justify-center mb-6">
          <Wine className="h-7 w-7 text-white" />
        </div>
        <p className="text-sm uppercase tracking-[0.25em] font-semibold text-white/70">Members</p>
        <h2 className="mt-4 font-serif text-3xl md:text-4xl lg:text-5xl font-medium">
          The Gledswood Wine Club
        </h2>
        <p className="mt-4 text-white/80 text-lg max-w-2xl mx-auto">
          Join a community of estate regulars. Add the wine club when you book, or
          sign up on your next visit.
        </p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto text-left">
          {perks.map((p) => (
            <div key={p} className="flex items-center gap-3 bg-white/8 rounded-xl px-5 py-4">
              <Check className="h-5 w-5 text-[#D4B24C] shrink-0" />
              <span className="text-white/90">{p}</span>
            </div>
          ))}
        </div>

        <button
          data-testid="wine-club-join-btn"
          onClick={scrollToBook}
          className="mt-12 px-8 py-4 rounded-full bg-white text-[#722F37] font-semibold text-lg hover:bg-white/90 transition-all hover:-translate-y-0.5"
        >
          Join when you book
        </button>
      </div>
    </section>
  );
}
